import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

/**
 * Komponente zum Zurücksetzen der Kamera auf eine bestimmte Position
 * Wird verwendet, wenn der Reset-Button geklickt wird
 */
export const CameraReset = ({ 
  targetPosition = [0, 0, 5], 
  targetRotation = [0, 0, 0],
  resetTrigger 
}) => {
  const { camera } = useThree();

  useEffect(() => {
    if (resetTrigger) {
      camera.position.set(...targetPosition);
      camera.rotation.set(...targetRotation);
      camera.updateProjectionMatrix();
    }
  }, [camera, targetPosition, targetRotation, resetTrigger]);

  return null;
};

